import React from "react"
import { ThemeConsumer } from "@rneui/themed"
import ResizablePosScreen from "./resizablePosScreen"
import SellscreenSummary from "./sellscreenPayment/sellscreenSummary"
import SellScreenPayment from "./sellscreenPayment/payment/sellscreenPayment"
import { getScreenPermission, useAppSelector } from "../../redux/hooks"
import { shallowEqual } from "react-redux"

export const OrderSummary = () => {
	const { isWrite } = useAppSelector(getScreenPermission("SellScreenStack"), shallowEqual)
	return (
		<ThemeConsumer>
			{({ theme }) => (
				<ResizablePosScreen
					LeftComponent={<SellscreenSummary />}
					rightComponent={<SellScreenPayment isWrite={isWrite} />}
					isorderSummary
				/>
			)}
		</ThemeConsumer>
	)
}